export const iconClassName = 'fui-Icon';
export const iconFilledClassName = 'fui-Icon-filled';
export const iconRegularClassName = 'fui-Icon-regular';
export const iconLightClassName = 'fui-Icon-light';
export const iconColorClassName = 'fui-Icon-color';
export const fontIconClassName = 'fui-Icon-font';
/**
 * Data attribute applied to every icon (SVG and font) for CSS targeting.
 * Enables selecting any icon from the catalogue via the `[data-fui-icon]` selector.
 */
export const DATA_FUI_ICON = 'data-fui-icon';
